// Aba Totem — ate 5 fotos/videos que passam em loop atras do "Faca seu
// pedido" na tela de descanso do totem. Pedido do dono (09/09/2026):
// videos/fotos de marketing pra atrair o cliente pro autoatendimento.

import { Clapperboard, Monitor } from "lucide-react";

import BannersCarregando from "./components/BannersCarregando";
import TotemMidiaCard from "./components/TotemMidiaCard";
import TotemUploader from "./components/TotemUploader";
import { useBanners } from "./hooks/useBanners";

export default function TotemMidiasTab() {
  const {
    banners, loading, enviando, maximo,
    adicionar, alternarAtivo, remover, mover,
  } = useBanners("totem");

  const noAr = banners.filter((b) => b.enabled).length;

  return (
    <div className="space-y-6" data-e2e="painel-totem-midias">
      <p className="text-xs text-muted-foreground -mt-2">
        {banners.length === 0
          ? `Até ${maximo} fotos ou vídeos.`
          : `${noAr} no ar de ${banners.length} cadastrada${banners.length === 1 ? "" : "s"} · máximo ${maximo}`}
      </p>

      <TotemUploader
        onArquivo={adicionar}
        enviando={enviando}
        desabilitado={banners.length >= maximo}
      />

      {loading ? (
        <BannersCarregando formato="totem" />
      ) : banners.length === 0 ? (
        <VazioTotem />
      ) : (
        <div className="space-y-3">
          <p className="text-xs text-muted-foreground">
            O totem passa as mídias nesta ordem: vídeo toca até o fim, foto fica 8 segundos.
            Sem mídia cadastrada, a tela usa o fundo padrão.
          </p>
          {banners.map((midia, i) => (
            <TotemMidiaCard
              key={midia.id}
              midia={midia}
              posicao={i}
              total={banners.length}
              onToggle={alternarAtivo}
              onRemover={remover}
              onMover={mover}
            />
          ))}
        </div>
      )}
    </div>
  );
}

function VazioTotem() {
  return (
    <div className="bg-card border border-border rounded-2xl p-8 md:p-12 flex flex-col items-center text-center">
      <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center mb-4">
        <Clapperboard className="w-8 h-8 text-primary" strokeWidth={1.5} />
      </div>
      <h2 className="text-lg font-semibold tracking-tight">Nenhuma mídia no totem</h2>
      <p className="text-sm text-muted-foreground mt-1.5 max-w-md">
        Fotos e vídeos ficam passando atrás do "Faça seu pedido" enquanto o totem
        espera um cliente. Use para mostrar lançamentos, combos e promoções.
        Tamanho ideal 1080 × 1920 px (em pé) — totem, tablet e TV vertical.
      </p>
      <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-muted text-xs font-medium text-muted-foreground mt-6">
        <Monitor className="w-3.5 h-3.5" strokeWidth={1.8} />
        Tela de descanso do totem
      </span>
    </div>
  );
}
